import React from 'react';
import { StyledRow, StyledSectionTitle } from './styles';
import { SectionTitleProps } from './types';

export type { SectionTitleProps } from './types';

export const SectionTitle: React.FC<SectionTitleProps> = ({
  as = 'h2',
  action,
  id,
  children,
}) => {
  if (action) {
    return (
      <StyledRow>
        <StyledSectionTitle as={as} id={id}>
          {children}
        </StyledSectionTitle>
        {action}
      </StyledRow>
    );
  }
  return (
    <StyledSectionTitle as={as} id={id}>
      {children}
    </StyledSectionTitle>
  );
};
